import React from "react";
import { Section, Reveal, Overline } from "./Primitives";
import { FOUNDER } from "../../data/content";

export const FounderStory = () => {
  return (
    <Section id="founder">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -inset-4 rounded-3xl bg-brand/5 blur-2xl" />
            <div className="relative rounded-3xl overflow-hidden border border-white/10">
              <img
                src={FOUNDER.image}
                alt="BuildRaq founder"
                loading="lazy"
                className="w-full h-[420px] md:h-[520px] object-cover brightness-[0.7] contrast-[1.05] grayscale-[0.2]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-void/70 to-transparent" />
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-brand/60" />
              <Overline>{FOUNDER.overline}</Overline>
            </div>
          </Reveal>
          <Reveal delay={0.06}>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight text-gradient max-w-xl">
              {FOUNDER.title}
            </h2>
          </Reveal>
          <div className="mt-8 space-y-5 max-w-xl">
            {FOUNDER.paragraphs.map((p, i) => (
              <Reveal key={i} delay={0.1 + i * 0.06}>
                <p className="text-base md:text-lg leading-relaxed text-muted-foreground">{p}</p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <div className="mt-8 font-heading text-lg text-white/80 italic">— {FOUNDER.signature}</div>
          </Reveal>
        </div>
      </div>
    </Section>
  );
};

export default FounderStory;
